import React, { useState } from "react";
import { Backdrop, Box, CircularProgress, Chip, Grid, IconButton, Paper, Typography } from "@mui/material";
import moment from "moment";
import currency from "currency.js";
import bkstApi from "../../common/component/api";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";

export default function Invoices(props) {
  const { orderId } = props;

  const [processing, setProcessing] = useState(false);

  const getBgColor = (status) => {
    if (status === "open") {
      return "#e67e22";
    } else if (status === "paid" || status === "refund") {
      return "#1abc9c";
    } else {
      return "#AAA";
    }
  };

  const chargeAddOnPayment = (invoiceId) => {
    if (window.confirm("Manually charge add-on payment?", orderId, invoiceId)) {
      setProcessing(true);
      bkstApi.put(`/admin/order/${orderId}/in/${invoiceId}/charge-offline`).then((res) => {
        window.location.reload();
      });
    }
  };

  return (
    <Box my={6}>
      <Grid container alignItems="center">
        <Grid item xs={6}>
          <Typography variant="overline" color="textSecondary">
            ADD-ONS
          </Typography>
        </Grid>
      </Grid>
      <Paper elevation={0}>
        <Box px={2} py={2}>
          {Object.entries(props.data)
            .sort()
            .map(([key, value]) => {
              return (
                <Box py={1}>
                  <Grid key={key} container alignItems="center">
                    <Grid item xs={8} sm={10}>
                      <Grid container alignItems="center">
                        <Grid item xs={12} sm={9}>
                          <Typography variant="body2" color="textSecondary">
                            {value.description}
                          </Typography>
                          {value.status === "open" && (
                            <Typography
                              variant="caption"
                              color="textSecondary"
                              dangerouslySetInnerHTML={{
                                __html: `&#128338; sent ${moment(value.ts).fromNow()}`
                              }}
                            ></Typography>
                          )}
                        </Grid>
                        <Grid item xs={12} sm={3}>
                          <Chip size="small" label={value.status} style={{ color: "#fff", backgroundColor: getBgColor(value.status) }} />
                        </Grid>
                      </Grid>
                    </Grid>
                    <Grid item xs={4} sm={2} align="right">
                      {value.status === "open" && (
                        <IconButton size="small" onClick={() => chargeAddOnPayment(key)}>
                          <CurrencyExchangeIcon />
                        </IconButton>
                      )}
                      <Typography variant="overline">{currency(value.amount.addOn).format()}</Typography>
                    </Grid>
                  </Grid>
                </Box>
              );
            })}
        </Box>
      </Paper>
      {processing && (
        <Backdrop open={true} style={{ zIndex: "1000", color: "#fff" }}>
          <CircularProgress color="inherit" />
        </Backdrop>
      )}
    </Box>
  );
}
